/*
 * @Description:
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-12-18 13:26:57
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbOrderPad {
    /**
     * 计算购物车商品售价
     */
    export var CalcOrderInfo = (body: any): Promise<any> => {
        return Post(`/api/TbOrder/CalcOrderInfoV4`, body);
    };
    /**Pad新增订单-预支付操作V2 */
    export var PostOrderV2 = (body: any): Promise<any> => {
        return Post(`/api/TbOrder/PostOrderV2`, body);
    };
    export var PostOrderV4 = (body: any): Promise<any> => {
        return Post(`/api/TbOrder/PostOrderV4`, body);
    };
    /**Pad订单支付(扫码动作) V2 */
    export var OrderPayV2 = (body: any): Promise<any> => {
        return Post(`/api/TbOrder/OrderPayV2`, body);
    };
    /**Pad订单支付(扫码动作) V2 */
    export var OrderPayV4 = (body: any): Promise<any> => {
        return Post(`/api/TbOrder/OrderPayV4`, body);
    };
    export var OrderPayV5 = (body: any): Promise<any> => {
        return Post(`/api/TbOrder/OrderPayV5`, body);
    };
    /**获取订单列表 */
    export var GetOrderList = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderList`, body);
    };
    /**获取订单详情 */
    export var GetOrderById = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderById`, body);
    };
    /**退货获取订单详情 */
    export var GetOrderReturnById = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderReturnById`, body);
    };
    /**
  * Pad首页获取主页销售订单信息
  */
    export var GetOrderHomepage = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderHomepageNew_V2`, body);
    };
    /**
     * Pad首页获取折线图
     */
    export var GetLineChart = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetLineChartNew_V2`, body);
    };
    /**
     * Pad首页获取热销商品
     */
    export var GetHotGoods = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetHotGoods`, body);
    };
    /**
     * 更改订单收银员
     */
    export var PutChangeCashier = (body: any): Promise<any> => {
        return Put(`/api/TbOrder/PutChangeCashier`, body);
    };
    /**
     * Pad取消支付
     */
    export var CancelPayV2 = (body: any): Promise<any> => {
        return Put(`/api/TbOrder/CancelPayV2`, body);
    };
    /**
     * 获取订单状态
     */
    export var GetOrderStatus = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderStatus`, body);
    };
    /**
     * 获取异常订单列表
     */
    export var GetAbnormalOrderListAsync = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetAbnormalOrderListAsync`, body);
    };
    /**
     * 获取异常订单详情
     */
    export var GetAbnormalOrderById = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetAbnormalOrderById`, body);
    };
    /**
     * 获取线上订单列表
     */
    export var GetOnlineOrderList = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOnlineOrderList`, body);
    };
    /**
     * 提货
     */
    export var PostOrderPickupGoodsReq = (body: any): Promise<any> => {
        return Post(`/api/TbOrder/PostOrderPickupGoodsReq`, body);
    };
    /**
     * 获取订单商品详情
     */
    export var GetOnlineOrderById = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOnlineOrderById`, body);
    };
    /**
     * 获取线上订单首页数量
     */
    export var GetOnlineOrderListNum = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOnlineOrderListNum`, body);
    };
    /**
     * pad首页-经营数据-退回商品
     */
    export var GetReturnGoodsDetailOperatePad = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetReturnGoodsDetailOperatePad`, body);
    };
    /**
     * pad首页-经营数据-退回商品合计
     */
    export var GetReturnGoodsDetailOperateTotalPad = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetReturnGoodsDetailOperateTotalPad`, body);
    };
    export var GetOrderStatusV2 = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderStatusV2`, body);
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbOrderPad.ts